import { Stage, IDP } from 'src/constants/constants';

export function getStage(): Stage {
  // gamma will be replaced during deployment by Katal Deployment Lambda with appropriate stage value.
  const stage = process.env.NODE_ENV !== 'production' ? Stage.DEV : (`gamma` as Stage);
  return stage;
}
